var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('finx-layout',{attrs:{"page-title":"Chat"},scopedSlots:_vm._u([{key:"container",fn:function(){return [_c('Filters',{staticClass:"backoffice-chat__filters"}),_c('List'),_c('Chat')]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }